import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';
import { useState, useMemo } from 'react';
import useAuth from 'src/hooks/useAuth';
import { useIntl } from 'react-intl';
import BasicsSection from './sections/BasicsSection';
import ToleranceSection from './sections/ToleranceSection';
import DictionarySection from './sections/DictionarySection';
import RelationshipsSection from './sections/RelationshipsSection';
import RiskAssessmentSection from './sections/RiskAssessmentSection';
import EvaluationSection from './sections/EvaluationSection';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';

export const SearchRiskDrawer = ({ model, configuracao }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  const showDictionary = useMemo(
    () => configuracao?.habilitarDicionarioRiscos,
    [configuracao]
  );

  const showTolerance = useMemo(
    () => configuracao?.habilitarAcompanhamentoToleranciaRisco,
    [configuracao]
  );

  return (
    <>
      <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <BasicsSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      <RelationshipsSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      {showDictionary && (
        <DictionarySection
          model={model}
          resources={resources}
          intl={intl}
          searchQuery={searchQuery}
        />
      )}

      <RiskAssessmentSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      <EvaluationSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      {showTolerance && (
        <ToleranceSection
          model={model}
          resources={resources}
          intl={intl}
          searchQuery={searchQuery}
        />
      )}

      <CustomFieldsSection
        model={model}
        intl={intl}
        searchQuery={searchQuery}
      />
    </>
  );
};

export default SearchRiskDrawer;
